module.exports = __webpack_public_path__ + "media/images/products/longlife/longlife-menu-img-1-6dce7a154d7eaa1209104802a254105d.png";